import { graph } from 'Model/constants'

export changeTypes = {
  CREATED: 'CREATED'
  UPDATED: 'UPDATED'
  REMOVED: 'REMOVED'
}

opTypes = [
  "remove-from-set"
  "add-to-set"
  "change-relation-key"
  "remove-relation"
  "create-relation"
  "remove-attribute"
  "create-attribute"
  "change-node-id"
  "change-attribute-key"
  "remove-node"
  "create-node"
]

nodeToLine = (op) ->
  "<#{op.id}>"
attributeToLine = (op) ->
  if op.datatype? and op.datatype isnt 'string' and op.datatype isnt 'xsd:string'
    "<#{op.sourceId}> <#{op.key}> \"#{op.value}\"^^<#{op.datatype}>"
  else
    "<#{op.sourceId}> <#{op.key}> \"#{op.value}\""
relationToLine = (op) ->
  "<#{op.sourceId}> <#{op.key}> <#{op.targetId}>"
removalToLine = (op) ->
  "<#{op.replacesId}>"

consumeOp = (lines, op) ->
  switch op.action
    when "create-node"
      lines += "+ #{nodeToLine(op)} .\n"
    when "create-relation"
      lines += "+ #{relationToLine(op)} .\n"
    when "create-attribute"
      lines += "+ #{attributeToLine(op)} .\n"
    when "remove-attribute"
      lines += "- #{removalToLine(op)} .\n"
    when "remove-relation"
      lines += "- #{removalToLine(op)} .\n"
    when "remove-node"
      lines += "- #{nodeToLine(op)} .\n"
  lines

export changesToTurtle = (stagedWrites) ->
  stagedWrites.reduce(consumeOp, '')

getSubsidiaryBranches = (branchHierarchyDict) -> (ref) ->
  _.map(branchHierarchyDict, (val, key) ->
    key if val is ref
  ).filter(Boolean)

getBranchHierarchy = ->
  branches = await Weaver.Branch.list()
  branches.reduce((acc, b) ->
    acc[b.id()] = b.getBaseBranchUid() or undefined # the server returns null
    acc
  , {})

export orderBranchesByHierarchy = ->
  result = []
  allBranches = await getBranchHierarchy()

  getNextSubsidiaries = (branches) ->
    next = branches.map((b) -> getSubsidiaryBranches(allBranches)(b)).flat()
    if next.length > 0
      result.push(next...)
      getNextSubsidiaries(next)

  bases = getSubsidiaryBranches(allBranches)(undefined)
  result.push(bases...)
  getNextSubsidiaries(bases)
  result

export assignBranches = (commits) ->
  branchHierarchy = await orderBranchesByHierarchy()
  heads = commits.filter(({ branches }) -> branches.length > 0)

  branchHierarchy.map((b) ->
    curr = heads.find((h) -> h.branches.indexOf(b) isnt -1)
    return unless curr
    curr.branch = b
    while (next = commits.find(({ uid }) -> curr.parentCommit is uid))
      return if next.branch?
      next.branch = b
      curr = next
  )

